import React, { useState, useEffect } from "react";
import FormInputStyle4 from "../../UIElements/FormInput";
import FormSelectStyle4 from "../../UIElements/FormSelect";
import FormButtonStyle4 from "../../UIElements/FormButton";
import ImageRadioButton from "../../UIElements/ImageRadioButtons";
import _ from "lodash";
import { toast } from "react-toastify";
import { getAllianceLeadFromMoneyTapInput } from "../../../../utility/commonUtils";
import { useDispatch, useSelector } from "react-redux";
import callApi from "../../../../utility/apiCaller";
import { useSearchParams } from "react-router-dom";
import { mapLeadRequestToResponse } from "../../Utils/leadmapperfunction";
import useAddLead from "../../hooks/addLeadtoCRM";
import Spinner from "../Spinner/spinner";
import { setAllOffers, setOffers } from "../../../../store/app/appReducer";
import { getCurrentLocation } from "../../Utils/GeoLocation";
import { setAAurl as SetAAUrlInstore } from "../../../../store/app/aaSlice";
import { setSelectedOffer as setOfferToStore } from "../../../../store/app/aaSlice";
import {
  setAppId,
  setInternalLead,
  setLeadId,
  setResponse,
  setUserData,
} from "../../../../store/app/aaSlice";
import useUserEvent from "../../../../hooks/setUserclickhook";
import { LoadingScreen } from "../FetchingOfferLoader/fetchingOffer";

const callApiWithRetryAndTest = async (
  apiFunc,
  retries,
  delay,
  testFunc,
  errorMsg
) => {
  return await withRetry(
    async () => {
      const res = await apiFunc();
      console.log(res);
      if (testFunc && !testFunc(res)) {
        throw new Error(errorMsg || "Validation failed");
      }
      return res;
    },
    retries,
    delay
  );
};

const isHero = (offers) => {
  const heroId = "67ef646df80610d286084e60";
  return offers.some((o) => o.lender_id === heroId);
};
const isLT = (offers) => {
  const Id = "662752eb65fdba1a48d6e482";
  return offers.some((o) => o.lender_id === Id);
};

const isDMI = (offers) =>
  offers.some((o) => o.lender_id === "68ad8ed5078abf6c677e4303");

const HERO_ID = "67ef646df80610d286084e60";
const LT_ID = "662752eb65fdba1a48d6e482";
const DMI_ID = "68ad8ed5078abf6c677e4303";

const withRetry = async (fn, retries = 3, delay = 1000) => {
  let attempt = 0;
  while (attempt < retries) {
    try {
      return await fn();
    } catch (err) {
      attempt++;
      if (attempt >= retries) throw err;
      console.warn(`Retrying... attempt ${attempt}`);
      await new Promise((res) => setTimeout(res, delay * attempt)); // backoff
    }
  }
};

function ProfessionalInformationForm({
  formData,
  setFormData,
  currentStep,
  setCurrentStep,
  setLead_id,
  setApplicationId,
  setResponseId,
  setMappedResponse,
  setAAUrl,
  setInternalLeadId,
}) {
  const [company_name, setcompany_name] = useState("");
  const [company_type, setcompany_type] = useState("");
  const [work_contact_email, setWorkEmail] = useState("");
  // const [failedList, setFailedList] = useState([]);
  const [activeLenders, setActiveLenders] = useState([]);
  const [isFinished, setIsFinished] = useState(false);
  const [monthly_income, setIncome] = useState("");
  const [loan_purpose, setloan_purpose] = useState("");
  const [occupation, setOccupation] = useState(""); // hidden sentence condition
  const [errors, setErrors] = useState({});
  const [ownership, setOwnership] = useState("");
  const [hasOffer, setHasOffer] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector((state) => state.app.user);
  const [params] = useSearchParams();
  const [isFetchingOffers, setIsFetchingOffers] = useState(false); // <-- new state
  const dispatch = useDispatch();
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [leadResponse, setLeadResponse] = useState({});
  // const [ip_address, setIp] = useState(null);
  const mobile = localStorage.getItem("mobile");
  const [timer, setTimer] = useState(null);
  const { trackUserEvent } = useUserEvent();
  // const [internalLeadId, setInternalLeadIdstate] = useState(null);
  const aaSlice = useSelector((state) => state?.aa);
  let leadId = null;
  let aaReq = false;
  const InternalLeadId = aaSlice?.internalLeadId;
  const addLead = useAddLead();
  const affId = params.get("aff_id");
  useEffect(() => {
    //console.log("leadResponse: ", leadResponse);
  }, [leadResponse]);

  const options = [
    {
      label: "Owned",
      value: "owned",
      selectedImage: "/images/selected.png",
      unselectedImage: "/images/unselected.png",
    },
    {
      label: "Rented",
      value: "rented",
      selectedImage: "/images/selected.png",
      unselectedImage: "/images/unselected.png",
    },
  ];

  useEffect(() => {
    const captureLocation = () => {
      getCurrentLocation(
        ({ latitude, longitude }) => {
          setLatitude(latitude);
          setLongitude(longitude);
          //console.log("Latitude:", latitude, "Longitude:", longitude);
        },
        (error) => {
          console.error("Failed to get location:", error.message);
        }
      );
    };
    captureLocation();
    // const fetchIp = async () => {
    //   try {
    //     const res = await fetch("https://api.ipify.org?format=json");
    //     const data = await res.json();
    //     setIp(data.ip);
    //     //console.log("ip address:", data.ip);
    //   } catch (error) {
    //     console.error("Error fetching IP:", error);
    //   }
    // };
    // fetchIp();
  }, [formData]);

  const fetchActiveLenders = async () => {
    try {
      const res = await callApi(`v1/lender/active-lenders`, "get", {}, "loan");
      if (res.status === "Success") {
        const apiLenders = res.data.lenderList ?? [];

        // const hardcodedLender = {
        //   _id: "662752eb65fdba1a48d6e482",
        //   lender_name: "L&T",
        // };

        const mergedLenders = [...apiLenders];

        setActiveLenders(mergedLenders);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // Load initial data if available
  useEffect(() => {
    if (formData) {
      setcompany_name(formData.company_name || "");
      setcompany_type(formData.company_type || "");
      setWorkEmail(formData.work_contact_email || "");
      setIncome(formData.monthly_income || "");
      setloan_purpose(formData.loan_purpose || "");
      setOccupation(formData.occupation || "");
      setOwnership(formData.ownership || "");
    }
  }, [formData]);

  // Live validation check
  useEffect(() => {
    const allValid =
      company_name.trim() &&
      company_type &&
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(work_contact_email) &&
      monthly_income &&
      !errors.monthly_income &&
      loan_purpose &&
      (formData.professionType !== "self_employed" || ownership);

    setIsFormValid(allValid);
  }, [
    company_name,
    company_type,
    work_contact_email,
    monthly_income,
    errors.monthly_income,
    loan_purpose,
    ownership,
  ]);

  const handleIncomeChange = (e) => {
    let value = e.target.value;

    // Remove non-digit characters
    value = value.replace(/\D/g, "");

    setIncome(value); // Store the cleaned numeric value
    if (value === "" || isNaN(Number(value)) || Number(value) < 25000) {
      setErrors((prev) => ({
        ...prev,
        monthly_income: "Income should be greater than ₹25,000",
      }));
    }

    if (timer) {
      clearTimeout(timer);
    }
    const rawValue = value;

    const newTimer = setTimeout(() => {
      // Already cleaned

      if (Number(rawValue) < 25000 && rawValue !== "") {
        setErrors((prev) => ({
          ...prev,
          monthly_income: "Income should be greater than ₹25,000 ",
        }));
      } else {
        setErrors((prev) => {
          const { monthly_income, ...rest } = prev;
          return rest; // Clear error if valid
        });
      }
    }, 100);

    setTimer(newTimer);
  };

  const pushHDMLead = async (leadId) => {
    if (affId !== "2") return;
    try {
      const res = await callApi(
        "v1/lead/hdm_lead_push",
        "post",
        { lead_id: leadId },
        "core",
        user?.token
      );

      return res; // return response to caller
    } catch (err) {
      console.error("HDM lead push failed:", err);
      return { status: "Error", error: err };
    }
  };

  const getleadData = async () => {
    const leadRes = await callApi(
      `v1/lead/list`,
      "post",
      {
        filters: {
          _id: InternalLeadId,
        },
      },
      "core",
      user?.token ||
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2OTAxYjljZjIxZTZlNTJmYTQwNDAwNDkiLCJvdHAiOiIxMTExIiwiY29udGFjdF9waG9uZSI6Ijk2OTMxMzU0NjYiLCJvdHBfZXhwaXJ5IjoiMjAyNS0xMC0yOVQwNzowMzowMy43MDZaIiwiaWF0IjoxNzYxNzIwNzg3fQ.xJ3Qd29aQPzV6vfc-bm5XDaOyIF1dXI4dD3lRZxEBDo"
    );
    console.log(leadRes.data.leadList[0]);
    const leadData = leadRes?.data?.leadList[0];

    const { application_id } = leadData;
  };

  // Handle validation
  const handleValidation = () => {
    const newErrors = {};

    if (!company_name.trim()) newErrors.company_name = true;
    if (!company_type) newErrors.company_type = true;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(work_contact_email))
      newErrors.work_contact_email = true;
    if (!monthly_income) newErrors.monthly_income = true;
    if (!loan_purpose) newErrors.loan_purpose = true;

    if (formData.professionType === "self_employed") {
      if (!ownership) newErrors.ownership = true;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Submit form
  const handleSubmit = async () => {
    if (!handleValidation()) return;

    try {
      setIsLoading(true);
      setIsFetchingOffers(true);

      // Update parent form data
      const updatedFormData = {
        ...formData,
        contact_phone: formData.mobile,
        company_name,
        company_type,
        work_contact_email,
        monthly_income,
        loan_purpose,
        occupation,
        ownership,
        city: formData.city,
        state: formData.state,
        latitude,
        longitude,
        // ip_address,
      };

      setFormData(updatedFormData);

      // Step 1: Lead generation
      const res = await callApi(
        `v1/lead/${InternalLeadId}/update-lead-new`,
        "post",
        {
          lead: {
            company_name: company_name || "",
            company_type: company_type || "",
            work_contact_email: work_contact_email || "",
            monthly_income: monthly_income || "",
            loan_purpose: loan_purpose || "",
            occupation: occupation || "",
            ownership: ownership || "",
            latitude: String(latitude),
            longitude: String(longitude),
            // ip_address: ip_address,
            steps_completed: 3,
          },
        },
        "core",
        user?.token ||
          "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2OTAxYjljZjIxZTZlNTJmYTQwNDAwNDkiLCJvdHAiOiIxMTExIiwiY29udGFjdF9waG9uZSI6Ijk2OTMxMzU0NjYiLCJvdHBfZXhwaXJ5IjoiMjAyNS0xMC0yOVQwNzowMzowMy43MDZaIiwiaWF0IjoxNzYxNzIwNzg3fQ.xJ3Qd29aQPzV6vfc-bm5XDaOyIF1dXI4dD3lRZxEBDo"
      );

      trackUserEvent("professional-page-for-e2eFeb", InternalLeadId);

      // let processLeadRes = await callApi(
      //   "v1/lead/process-lead-for-loan-zv4",
      //   "post",
      //   { contact_phone: mobile || formData.mobile },
      //   "core",
      //   user.token
      // );
      ///////////////////////////////////////////////////////////////////////////////////////////////////////////////
      const ltResponse = await callApi(
        "v1/lender_api_call/list",
        "post",
        {
          filters: {
            lead_id: InternalLeadId,
            lender_name: {
              $in: ["DMI", "Hero Fincorp","Aditya Birla Capital"],
            },
          },
          pageSize: 10,
          pageNum: 1,
        },
        "loan_service"
      );

      const lendersData = await callApi(
        "v1/lender/list",
        "post",
        {
          filters: {
            name: { $in: ["DMI", "Hero Fincorp","Aditya Birla Capital"] },
          },
          pageSize: 10,
          pageNum: 1,
        },
        "loan_service",
        user.token
      );

      // safe helpers
      const hasLenderCall = (name) =>
        (ltResponse?.data?.lender_api_callList || []).some(
          (entry) => entry.lender_name === name
        );

      const getLenderMeta = (name) =>
        (lendersData?.data?.lenderList || []).find((l) => l.name === name) ||
        null;

      // push L&T if needed (initial push before polling)
      const dmiMeta = getLenderMeta("DMI");
      if (
        !hasLenderCall("DMI") &&
        dmiMeta &&
        dmiMeta.otp_page_api_push === true
      ) {
        console.log("Calling bulk-lead-push-by-leadId for DMI", {
          leads: [{ lead_id: InternalLeadId }],
          lender_name: "DMI",
          lender_id: dmiMeta._id || "68ad8ed5078abf6c677e4303",
        });

        await callApi(
          "v1/lead/bulk-lead-push-by-leadId",
          "post",
          {
            leads: [{ lead_id: InternalLeadId }],
            lender_name: "DMI",
            lender_id: dmiMeta._id || "68ad8ed5078abf6c677e4303",
          },
          "core",
          user.token
        );
      }

      const heroMeta = getLenderMeta("Hero Fincorp");
      if (
        !hasLenderCall("Hero Fincorp") &&
        heroMeta &&
        heroMeta.otp_page_api_push === true
      ) {
        console.log("Calling bulk-lead-push-by-leadId for Hero Fincorp", {
          leads: [{ lead_id: InternalLeadId }],
          lender_name: "Hero Fincorp",
          lender_id: heroMeta._id || "67ef646df80610d286084e60",
        });

        await callApi(
          "v1/lead/bulk-lead-push-by-leadId",
          "post",
          {
            leads: [{ lead_id: InternalLeadId }],
            lender_name: "Hero Fincorp",
            lender_id: heroMeta._id || "67ef646df80610d286084e60",
          },
          "core",
          user.token
        );
      }

      
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////
      // let processLeadRes = await withRetry(
      //   () =>
      //     callApi(
      //       "v1/lender/dmi-create-application?lender_id=67b82660c4058e568491673c",
      //       "post",
      //       {
      //         contact_phone: mobile || formData.mobile,
      //         id: InternalLeadId,
      //       },
      //       "loan"
      //     ),
      //   1, // retry once
      //   2000 // wait 2s before retry
      // );
      // if (processLeadRes?.status === "Success") {
      const pollOffers = async (attempt = 1) => {
      const result = await fetchOffers(InternalLeadId);

      if (result?.success && result.offers.length > 0) {
        setHasOffer(true);
        dispatch(
          setAllOffers({
            offers: result.offers,
            failedList: result.failedList,
          })
        );
        return true; // ✅ offers found
      }

      // stop after 10 attempts (~50s)
      if (attempt >= 10) {
        return false; // ❌ no offers
      }

      // retry after 5 sec
      return new Promise((resolve) =>
        setTimeout(
          async () => resolve(await pollOffers(attempt + 1)),
          5000
        )
      );
    };


      // Wait for polling to finish
      //await pollOffers();
      // Wait for polling to finish
      const hasAnyOffer = await pollOffers();

      if (!hasAnyOffer) {
        console.log(
          "No offers from Aditya Birla Capital & Muthoot. Calling fallback process-lead API"
        );

        await callApi(
          "v1/lead/process-lead-for-loan-zv4",
          "post",
          {
            contact_phone: mobile || formData.mobile,
          },
          "core",
          user.token
        );
      }

      const abflMeta = getLenderMeta("Aditya Birla Capital");
      if (
        !hasLenderCall("Aditya Birla Capital") &&
        abflMeta &&
        abflMeta.otp_page_api_push === true
      ) {
        console.log("Calling bulk-lead-push-by-leadId for DMI", {
          leads: [{ lead_id: InternalLeadId }],
          lender_name: "Aditya Birla Capital",
          lender_id: abflMeta._id || "662752eb65fdba1a48d6e480",
        });

        await callApi(
          "v1/lead/bulk-lead-push-by-leadId",
          "post",
          {
            leads: [{ lead_id: InternalLeadId }],
            lender_name: "Aditya Birla Capital",
            lender_id: abflMeta._id || "662752eb65fdba1a48d6e480",
          },
          "core",
          user.token
        );
      }

      await pollOffers();

      // Move to next step
      //commented on 20th Jan as it's always shows AA page although it's timeout
      //setCurrentStep((prev) => prev + 1);
      setCurrentStep(7);
      // await pushHDMLead(InternalLeadId);
      // if (hasOffer) {
      //   try {
      //     await addLead({
      //       leadId: InternalLeadId,
      //       lead_type: "live",
      //       priority: 2,
      //       stage: "Have offer",
      //     });
      //   } catch (error) {
      //     console.error("Error adding lead to CRM:", error);
      //   }
      // } else {
      //   try {
      //     await addLead({
      //       leadId: InternalLeadId,
      //       lead_type: "live",
      //       priority: 2,
      //       stage: "Professional Details",
      //     });
      //   } catch (error) {
      //     console.error("Error adding lead to CRM:", error);
      //   } finally {
      //     setCurrentStep(6);
      //   }
      // }
      // }
    } catch (err) {
      console.error(err);
      // setCurrentStep(4);
      if (err.message === "No Offer Callback received") {
        setCurrentStep(6);
      }
      toast.error(err.message || "Application Failed");
    } finally {
      setIsLoading(false);
      setIsFetchingOffers(false);
    }
  };

  const fetchOffers = async (leadId) => {
    if (!leadId || isFinished) return false;

    try {
      // Step 1: Get base offers
      const res = await callApi(
        `v1/loan_offer/lead_id/${leadId}`,
        "get",
        {},
        "core",
        user.token
      );

      if (res.status !== "Success" || !Array.isArray(res.data?.offers)) {
        return { success: false, offers: [] };
      }

      const baseOffers = res.data.offers;

      // Step 2: Get lender success + fail list
      const lenderListRes = await callApi(
        `v1/lender_api_call/${leadId}/get-fail-success-lenders`,
        "post",
        {},
        "loan",
        user.token
      );

      const failedList = lenderListRes.data?.FailList || [];

      let lenderMap = {};
      if (
        lenderListRes.status === "Success" &&
        Array.isArray(lenderListRes.data?.Successlist)
      ) {
        lenderMap = Object.fromEntries(
          lenderListRes.data.Successlist.map((lender) => [
            lender.lender_id,
            lender,
          ])
        );
      }

      // Step 3: Enrich offers with lenderMap
      const enrichedOffers = baseOffers.map((offer) => {
        const lender = lenderMap[offer.lender_id] || {};

        return {
          ...offer,
          apr: lender.apr ?? "",
          kfs_doc: lender.kfs_doc ?? "",
          credit_limit: lender.web_offer ?? "",
          penal_charges: lender.penal_charges ?? "",
          processing_fee: lender.processing_fee ?? "",
          interest_rate: lender.web_interest ?? null,
          lender_name: lender.lender_name ?? offer.lender_name,
        };
      });

      // Step 4: Sort by priority if available
      const sortedOffers = _.orderBy(enrichedOffers, ["priority"], ["asc"]);

      // Step 5: Apply active lender filter if needed
      const filteredOffers = activeLenders.length
        ? sortedOffers.filter((offer) =>
            activeLenders.some((lender) => lender._id === offer.lender_id)
          )
        : sortedOffers;

      return {
        success: true,
        offers: filteredOffers,
        failedList: failedList,
      };
    } catch (err) {
      console.error("Error in offer fetching", err);
      toast.error("Something went wrong while fetching offers.");
      setIsFinished(true);
      return { success: false, offers: [] };
    }
  };

  if (isFetchingOffers) return <LoadingScreen />;

  return (
    <div className="font-polysans mt-2">
      {/* Form Title */}
      <div className="flex items-center gap-3 w-full px-2.5  ">
        <div className="w-10 border-t border-gray-300"></div>
        <h1 className="text-[clamp(1rem,5vw,20px)] font-atkinson-bold ">
          Professional information
        </h1>
        <div className="w-10 border-t border-gray-300"></div>
      </div>
      <p className="text-center text-[12px] font-atkinson mb-3 text-[#818181]">
        You’re just a few steps away from your ideal loan!
      </p>

      {/* Inputs */}
      <FormInputStyle4
        label="Company Name"
        maxlength={100}
        value={company_name}
        onChange={(e) => {
          // Remove any character that is not a letter or space
          let newName = e.target.value;
          newName = newName.replace(/[^A-Za-z\s]/g, "");

          // Replace multiple spaces with a single space
          newName = newName.replace(/\s+/g, " ");
          setcompany_name(newName);
        }}
        isValid={!errors.company_name}
        errorMessage="Company name is required"
      />

      <FormSelectStyle4
        label="Company Type"
        value={company_type}
        onChange={(val) => setcompany_type(val)}
        options={[
          { label: "Private Limited Company (Pvt Ltd)", value: "private" },
          { label: "Public Limited Company", value: "public" },
          { label: "Partnership", value: "partnership" },
          { label: "Proprietorship", value: "proprietorship" },
        ]}
        isValid={!errors.company_type}
        errorMessage="Please select company type"
      />

      <FormInputStyle4
        label="Work Email Address"
        value={work_contact_email}
        maxlength={100}
        onChange={(e) => setWorkEmail(e.target.value)}
        isValid={!errors.work_contact_email}
        errorMessage="Enter a valid work email"
      />

      <FormInputStyle4
        label="Monthly Income"
        value={
          monthly_income
            ? new Intl.NumberFormat("en-IN").format(monthly_income)
            : ""
        }
        onChange={handleIncomeChange}
        maxlength={100}
        isValid={!errors.monthly_income}
        errorMessage={errors.monthly_income ? errors.monthly_income : ""}
      />

      <FormSelectStyle4
        label="Purpose of Loan"
        value={loan_purpose}
        onChange={(e) => setloan_purpose(e)}
        options={[
          { label: "Wedding/Other Events", value: "wedding/other events" },
          { label: "Medical Expenses", value: "medical expenses" },
          { label: "Home Renovation", value: "home renovation" },
          { label: "Travel Expenses", value: "travel expenses" },
          { label: "Education Expenses", value: "education expenses" },
          { label: "Business Expenses", value: "business expenses" },
          { label: "Electronics Purchase", value: "electronics purchase" },
          { label: "Jewellery Purchase", value: "jewellery purchase" },
          {
            label: "Stock Market Trading/Investment",
            value: "stock market trading/investment",
          },
          {
            label: "Betting/Gambling/Speculative purposes",
            value: "betting/gambling/speculative purposes",
          },
          { label: "Other Personal Use", value: "other personal use" },
        ]}
        isValid={!errors.loan_purpose}
        errorMessage="Please select purpose"
      />

      {/* Conditionally shown message */}
      {/* {(occupation === "self_employed" || formData.professionType === "self_employed") && (
        <p className="text-red-500 text-[10px] mt-1 mb-3">
          *Applicable only if the user selects ‘Self-Employed’ as their
          occupation.
        </p>
      )} */}

      {/* Business Ownership */}
      {formData.professionType === "self_employed" && (
        <div className="p-2">
          <p className="mb-2 font-atkinson text-[#1B1B1B] text-[14px]">
            Business ownership type
          </p>
          <ImageRadioButton
            options={options}
            name="businessOwnership"
            selectedValue={ownership}
            onChange={setOwnership}
          />
        </div>
      )}

      {/* Submit Button */}
      <FormButtonStyle4
        className="mt-4 mb-6"
        text="Get My Offers"
        disabled={!isFormValid || isLoading}
        isLoading={isLoading}
        onClick={handleSubmit}
      />
    </div>
  );
}

export default ProfessionalInformationForm;
